module.exports = __webpack_public_path__ + "img/swad.2a0457bb.jpg";